import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { BOOK_NOW_URL, isExternalBookingURL } from "@/config/booking";

/**
 * Returns a handler that opens the configured booking URL.
 * External URLs open in a new tab; internal routes use react-router.
 */
export function useBookNow() {
  const navigate = useNavigate();
  return useCallback(() => {
    if (isExternalBookingURL()) {
      window.open(BOOK_NOW_URL, "_blank", "noopener,noreferrer");
    } else {
      navigate(BOOK_NOW_URL);
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [navigate]);
}
